var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useRef, useEffect } from 'react';
import { useImmer } from 'use-immer';
import Editor from 'react-medium-editor';
import { useInputSearch } from '../../ui';
import keyBy from 'lodash/keyBy';
import clsx from 'clsx';
import isString from 'lodash/isString';
import { XR } from '..';
import countries from '../../data/countries.json';
var className = 'XR-useForm';
var refs = {
    id: window.document.querySelector('div'),
};
export function useForm(input) {
    var initialValues = useState(getValues(input, 'value'))[0];
    var _a = useImmer(getValues(input, 'value')), inputValues = _a[0], setInputValues = _a[1];
    var inputByField = keyBy(input, function (item) { return item.field; });
    var formId = useState(Math.random())[0];
    refs[formId] = refs[formId] || {};
    function getData() {
        var output = {};
        Object.keys(inputValues).forEach(function (field) {
            var _a;
            var setValue = function (value) {
                output[field] = value;
            };
            var value = inputValues[field];
            var type = (_a = inputByField[field]) === null || _a === void 0 ? void 0 : _a.type;
            if (value === undefined) {
                setValue(undefined);
            }
            else if (type === 'currency' && value) {
                setValue(Number(value) * 100);
            }
            else if (type === 'number' && value) {
                setValue(Number(value));
            }
            else if (type === 'boolean') {
                setValue(Boolean(value));
            }
            else if (value) {
                setValue(value);
            }
            else {
                setValue(null);
            }
        });
        return output;
    }
    useEffect(function () {
        return function () {
            delete refs[formId];
        };
    }, []);
    return {
        getInput: function (field) {
            return (React.createElement(Input, { field: field, form: inputValues, setForm: setInputValues, inputByField: inputByField, onRef: function (ref) {
                    if (ref && refs && refs[formId]) {
                        refs[formId][field] = ref;
                    }
                } }));
        },
        getData: getData,
        getDataField: function (field) {
            return getData()[field];
        },
        setValue: function (form) {
            setInputValues(function (inputValues) {
                Object.keys(form || {}).forEach(function (field) {
                    var _a;
                    var value = form[field];
                    if (((_a = inputByField[field]) === null || _a === void 0 ? void 0 : _a.type) === 'currency') {
                        inputValues[field] = (value || 0) / 100;
                    }
                    else {
                        inputValues[field] = value;
                    }
                });
            });
        },
        reset: function () {
            setInputValues(function () { return (__assign({}, initialValues)); });
        },
        clear: function () {
            setInputValues(function () {
                var values = {};
                input.forEach(function (_a) {
                    var field = _a.field, type = _a.type;
                    values[field] = type === 'phone' ? {} : undefined;
                });
                return values;
            });
        },
        focus: function (field) {
            var _a, _b;
            (_b = (_a = refs === null || refs === void 0 ? void 0 : refs[formId]) === null || _a === void 0 ? void 0 : _a[field]) === null || _b === void 0 ? void 0 : _b.focus();
        },
    };
}
function Input(_a) {
    var _b, _c, _d, _e, _f;
    var field = _a.field, form = _a.form, setForm = _a.setForm, inputByField = _a.inputByField, onRef = _a.onRef;
    var inputProps = inputByField[field];
    var type = inputProps.type, label = inputProps.label, prependIcon = inputProps.prependIcon, prepend = inputProps.prepend, append = inputProps.append, appendIcon = inputProps.appendIcon, nullable = inputProps.nullable, helperText = inputProps.helperText, disabled = inputProps.disabled;
    var isTypePhone = type === 'phone';
    var classType = "type-" + type;
    var ref = useRef();
    var placeholder = (_b = inputProps.placeholder) !== null && _b !== void 0 ? _b : label;
    useEffect(function () {
        onRef(ref.current);
    }, [ref.current]);
    var areaCodeDialog = useDialogAreaCode({
        onSelect: function (areaCode) {
            setForm(function (values) {
                values[field] = values[field] || {};
                values[field].areaCode = areaCode;
            });
            areaCodeDialog.close();
        },
    });
    var value;
    if (isTypePhone) {
        value = (_d = (_c = form[field]) === null || _c === void 0 ? void 0 : _c.phone) !== null && _d !== void 0 ? _d : '';
    }
    else {
        value = (_e = form[field]) !== null && _e !== void 0 ? _e : '';
    }
    function setValue(field, value) {
        setForm(function (values) {
            values[field] = value;
        });
    }
    function getInputProps() {
        var type = {
            string: 'text',
            number: 'number',
            currency: 'number',
            email: 'email',
            phone: 'tel',
        };
        return __assign(__assign({}, inputProps === null || inputProps === void 0 ? void 0 : inputProps.inputProps), { type: type[inputProps.type], placeholder: placeholder, disabled: disabled });
    }
    if (type === 'select') {
        return (React.createElement(Select, __assign({}, inputProps, { value: value, onSelect: function (value) {
                setValue(field, value);
            }, onClear: clearValue })));
    }
    if (type === 'boolean') {
        var variant = inputProps.variant;
        var classes = clsx(className, classType, { isActive: value }, "variant-" + variant);
        if (variant === 'toggle') {
            return (React.createElement(XR.Button, { onClick: function () {
                    setValue(field, !value);
                }, className: classes, iconEnd: value ? 'toggle_on' : 'toggle_off', color: value ? 'success' : 'default', variant: 'outlined', fullWidth: true }, label));
        }
        if (variant === 'checkbox') {
            return (React.createElement(XR.Button, { onClick: function () {
                    setValue(field, !value);
                }, className: classes, iconStart: value ? 'check_box' : 'check_box_outline_blank', color: value ? 'success' : 'default', variant: 'outlined', fullWidth: true }, label));
        }
    }
    var hasValue = Boolean(value);
    var prependExtra;
    function clearValue() {
        setForm(function (input) {
            if (isTypePhone) {
                input[field].phone = undefined;
            }
            else {
                input[field] = null;
            }
        });
    }
    var element;
    var inputElement = (React.createElement("input", __assign({ ref: ref, value: value, onChange: function (event) {
            var value = event.target.value;
            if (isTypePhone) {
                setForm(function (values) {
                    values[field] = values[field] || {};
                    values[field].phone = value;
                });
            }
            else {
                setValue(field, value);
            }
        } }, getInputProps())));
    if (type === 'editor') {
        element = (React.createElement(Editor, { text: value, onChange: function (value) {
                setValue(field, value);
            }, options: {
                placeholder: {
                    text: placeholder,
                },
            } }));
    }
    else if (type === 'textarea') {
        element = (React.createElement("textarea", __assign({ value: value, onChange: function (event) { return setValue(field, event.target.value); }, rows: 3 }, getInputProps())));
    }
    else if (isTypePhone) {
        var areaCode = (_f = form[field]) === null || _f === void 0 ? void 0 : _f.areaCode;
        prependExtra = (React.createElement(XR.Button, { onClick: areaCodeDialog.open, variant: 'text' },
            "+",
            areaCode));
        element = inputElement;
    }
    else {
        element = inputElement;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("label", { className: clsx(className, classType, 'input-container') },
            prependIcon && React.createElement(XR.Button, { className: 'icon', icon: prependIcon }),
            prepend,
            prependExtra,
            element,
            append,
            appendIcon && React.createElement(XR.Button, { className: 'icon', icon: appendIcon }),
            nullable && hasValue && getClearableButton({ onClear: clearValue }),
            label && value && React.createElement("div", { className: 'floating-label' }, label)),
        areaCodeDialog.element));
}
function useDialogAreaCode(_a) {
    var onSelect = _a.onSelect;
    var inputSearch = useInputSearch();
    var countriesFiltered = inputSearch.filter(countries, 'name');
    var list = XR.useList({
        items: countriesFiltered.map(function (country) { return ({
            type: 'text',
            title: country.name,
            value: country.number,
            onClick: function () { return onSelect(country.number.replace('+', '')); },
        }); }),
    });
    return XR.useDialog({
        header: { title: 'Choose country' },
        content: (React.createElement(React.Fragment, null,
            React.createElement(XR.Section, null, inputSearch.element),
            list.element)),
    });
}
function getValues(list, field) {
    var output = {};
    list.forEach(function (item) {
        if (item.type === 'currency') {
            if (item[field]) {
                output[item.field] = item[field] / 100;
            }
        }
        else {
            output[item.field] = item[field];
        }
    });
    return output;
}
function Select(input) {
    var label = input.label, value = input.value, onSelect = input.onSelect, onClear = input.onClear, type = input.type, _a = input.options, options = _a === void 0 ? [] : _a, placeholder = input.placeholder, nullable = input.nullable, mapValue = input.mapValue, disabled = input.disabled;
    var selectedOption = options.find(function (option) { return option.value === value; });
    var inputSearch = useInputSearch();
    var classType = "type-" + type;
    var isStringInput = options.filter(function (option) { return isString(option.label); }).length === options.length;
    var optionsFiltered = isStringInput ? inputSearch.filter(options, 'label') : options;
    var optionsDialog = XR.useDialog({
        toggleElement: (React.createElement(XR.Touchable, { className: clsx(className, classType, 'select-toggle-button', { disabled: disabled }), align: 'center', round: true },
            label && selectedOption && React.createElement("div", { className: 'XR-useForm floating-label' }, label),
            React.createElement("div", null, selectedOption ? ((mapValue === null || mapValue === void 0 ? void 0 : mapValue(selectedOption)) || selectedOption.label) : (React.createElement("span", { className: 'placeholder' }, placeholder))),
            React.createElement(XR.Box, null,
                nullable && selectedOption && getClearableButton({ onClear: onClear }),
                React.createElement(XR.Button, { icon: 'arrow_drop_down', className: 'input-button-icon', variant: 'text' })))),
        className: clsx(className, classType),
        header: { title: input.label },
        content: (React.createElement(React.Fragment, null,
            isStringInput && React.createElement(XR.Section, null, inputSearch.element),
            React.createElement(XR.Section, null, optionsFiltered.map(function (option) { return (React.createElement(XR.Button, { onClick: function () {
                    onSelect(option.value);
                    optionsDialog.close();
                }, key: option.value, variant: 'text', fullWidth: true, className: clsx(classType, 'select-item'), iconEnd: 'keyboard_arrow_right' }, (mapValue === null || mapValue === void 0 ? void 0 : mapValue(option)) || option.label)); })))),
    });
    useEffect(function () {
        if (optionsDialog.isOpen) {
            return function () {
                inputSearch.clear();
            };
        }
    }, [optionsDialog.isOpen]);
    return optionsDialog.element;
}
function getClearableButton(_a) {
    var onClear = _a.onClear;
    return (React.createElement(XR.Button, { onClick: function (event) {
            onClear();
            event.stopPropagation();
            event.preventDefault();
        }, variant: 'text', icon: 'close' }));
}
